import { Heading } from '@/components';
import styles from './AccordionHeading.module.scss';
import className from 'classnames/bind';

let cx = className.bind(styles);

export function AccordionHeading({ children, className, accordionSettings }) {
	const { id, isOpen, openItem, handleOpen, openIcon, closeIcon } = accordionSettings;
	const classNameArray = className?.split(' ') || [];

	return (
		<div className={cx(['ns_accordion-header', 'accordion-header', ...classNameArray])}>
			<button id={`accoridon-button-${id}`} className={cx(['ns_accordion-header-button', 'accordion-header-button'])} onClick={handleOpen} aria-controls={`accoridon-details-${id}`} aria-expanded={isOpen || openItem?.id === `${id}` ? true : false}>
				<div className={cx(['ns_accordion-header-button-container', 'accordion-header-button-container'])}>
					<div className={cx(['ns_accordion-header-text-container', 'accordion-header-text-container'])}>{children}</div>
					<div className={cx(['ns_accordion-icon-container', 'accordion-icon-container'])}>{isOpen || openItem?.id === `${id}` ? closeIcon : openIcon}</div>
				</div>
			</button>
		</div>
	);
}
